// extracted by mini-css-extract-plugin
module.exports = {"searchWrap":"viewWorkplaces_searchWrap__3I38g","searchBar":"viewWorkplaces_searchBar__1Z4pc","addNewBtn":"viewWorkplaces_addNewBtn__1zJQp"};